import React, {Component} from 'react';
import Prismic from 'prismic-javascript'
import {PrismicConfig} from '../../../../../helpers/prismicHelpers/PrismicAPI'
import {LanguagePrismicHelper} from '../../../../../helpers/prismicHelpers/PrismicHelpers'
import {myDownloadsPageHelper} from '../../../../../helpers/prismicHelpers/prismic-custom-helpers/MyDownloadsHelpers'
import {
    prismicSliceHelper,
    prismicSliceContentRelationship
} from '../../../../../helpers/prismicHelpers/prismic-slice-helpers/PrismicSliceHelpers'
import {sliceComponentsHelper} from '../../../../../helpers/prismicHelpers/prismic-slice-helpers/SliceComponentsHelpers'
import Loader from '../../../../common/elements/Loader';
import DocumentsCard from '../../../../dashboardNew/components/cards/DocumentsCard';

class DocumentsPage extends Component {
    state = {
        slices: null,
        documents: null
    }

    async componentDidMount() {
        //prismic
        const prismicConnection = await Prismic.api(PrismicConfig.apiEndpoint, {accessToken: PrismicConfig.apiAccessTokes});
        const json = await prismicConnection.query(Prismic.Predicates.at('document.type', 'my-downloads'), LanguagePrismicHelper());
        let {slices} = prismicSliceHelper(json);
        let {documents} = myDownloadsPageHelper(json);
        slices = (slices && slices.length) ? await prismicSliceContentRelationship(slices, prismicConnection) : null;
        this.setState({slices, documents})
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.state.slices !== nextState.slices
    }

    getDocs(documents) {
        if (!documents) {
            return
        }
        ;
        return documents.map(document => {
            let data = {...document};
            data.url = data.document_url;
            delete data.document_url;
            return <DocumentsCard key={data.title} documentsData={data}/>
        });
    }

    render() {

        const {slices, documents} = this.state;

        if (!slices) return <Loader/>

        return (
            <React.Fragment>
                {sliceComponentsHelper(slices)}
                <div className="container documents-page theme-page-content-wrapper">
                    <div className="row">
                        <div className="col-12 heading-section no-margin">
                            <p className="body-copy">{slices[0].subtitle}</p>
                        </div>
                        {this.getDocs(documents)}
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default DocumentsPage;


// WEBPACK FOOTER //
// src/client/components/site/features/documents/pages/DocumentsPage.js